export const configs = {
  dev_domain_url: "http://www.pricepinger.com",

  get_token_api_endpoint: "/token",
  validate_token_api_endpoint: "/token/validate",
  logout_api_endpoint: "/logout/",
  signup_api_endpoint: "/signup/",
  verify_email_api_endpoint: "/verify-email/",
  change_password_api_endpoint: "/change-password/",
  user_details_api_endpoint: "/user/",

  retailers_config_api_endpoint:
    "/product/retailer_query_selector/?retailer=JIOMART&landing_page=1&query_selector=1",
  get_customized_title_endpoint: `/product/get_customized_title/`,
  product_scrape_data_api_endpoint: "/product/scrape_data/",
  retailer_tag_api_endpoint: "/product/retailer_tag/",

  top_deals_api_endpoint: "/products",
  banners_api_endpoint:
    "/banners?acf_format=standard&_fields=id,title.rendered,acf.banner_image,acf.banner_url,acf.banner_alt,acf.banner_retailer",

  blog_thumbnail_api_endpoint: "/media/",
  blogs_api_endpoint: "/posts?_fields=id,title.rendered,link,featured_media",
  blog_posts_api_endpoint: "/posts/",
  blog_content_api_endpoint: "?_fields=title,content",
  blog_title_search_api_endpoint: "/posts?search=",
  pages_api_endpoint: "/pages/",
  product_details_api_endpoint: "/product-details/",
  product_google_search_api_endpoint: "/product-gsearch/",
  product_save_api_endpoint: "/product-save/",
  product_search_api_endpoint: "/product-search/",
  product_deal_api_endpoint:
    "/product_deals?acf_format=standard&_fields=id,title.rendered,acf.product_deals_image,acf.product_deals_url,acf.product_deals_alt,acf.product_deals_retailer",
  todays_deal_api_endpoint:
    "/todays_deal?acf_format=standard&_fields=id,title.rendered,acf.todays_deal_image,acf.todays_deal_url,acf.todays_deal_alt,acf.todays_deal_retailer",
  bank_offers_api_endpoint:
    "/bank_offers?acf_format=standard&_fields=id,title.rendered,acf.bank_offers_image,acf.bank_offers_url,acf.bank_offers_alt,acf.bank_offers_retailer",
  seasonal_sales_api_endpoint:"/seasonal_sales?acf_format=standard&_fields=id,title.rendered,acf.seasonal_sales_image,acf.seasonal_sales_url,acf.seasonal_sales_alt,acf.seasonal_sales_retailer",
  affliate_params: "pricepinger07-21",
  grap_the_plugin_url:
    "https://chromewebstore.google.com/detail/price-pinger-plugin/plhjnaoodjmclojgcmlgnaojkpddggic",
  get_country_code_api_endpoint: "https://ipapi.co/json/",
  retailer_logo_api_endpoint:"/retailer_logo"
};
